// extracted by mini-css-extract-plugin
export default {"root":"Label_root__0nfs5","label":"Label_label__Zz0X1"};